const $transferable = Symbol("threads-es.transferable");
export function isTransferDescriptor(thing) {
    return thing && typeof thing === "object" && thing[$transferable];
}
export function Transfer(payload, transferables) {
    if (!transferables) {
        transferables = [payload];
    }
    return {
        [$transferable]: true,
        send: payload,
        transferables
    };
}
